export default __webpack_public_path__ + "static/media/logo-img@3x.7745c800.1d89548c.png";